import React from 'react';

interface HeartOutlinedIconProps {
  className?: string;
}

function HeartOutlinedIcon({ className }: HeartOutlinedIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      fill="none"
      viewBox="0 0 24 25"
      className={className}
    >
      <g id="favorite">
        <mask
          id="mask0_13282_44292"
          width="25"
          height="25"
          x="0"
          y="0"
          maskUnits="userSpaceOnUse"
          style={{ maskType: 'alpha' }}
        >
          <path id="Bounding box" fill="#D9D9D9" d="M.047.382h24v24h-24z"></path>
        </mask>
        <g mask="url(#mask0_13282_44292)">
          <path
            id="favorite_2"
            fill="currentColor"
            d="M12.047 20.707q-.35 0-.713-.125a1.65 1.65 0 0 1-.637-.4l-1.725-1.575a68 68 0 0 1-4.788-4.812q-2.137-2.388-2.137-5.263 0-2.35 1.575-3.925t3.925-1.575q1.325 0 2.5.563t2 1.537a5.96 5.96 0 0 1 2-1.537 5.7 5.7 0 0 1 2.5-.563q2.35 0 3.925 1.575 1.575 1.576 1.575 3.925 0 2.875-2.125 5.275a60 60 0 0 1-4.825 4.825l-1.7 1.55a1.65 1.65 0 0 1-.638.4q-.362.125-.712.125m-.95-13.575q-.725-1.025-1.55-1.562t-2-.538q-1.5 0-2.5 1t-1 2.5q0 1.3.925 2.763t2.212 2.837a38 38 0 0 0 2.65 2.575q1.363 1.2 2.213 1.975.85-.774 2.212-1.975 1.363-1.2 2.65-2.575a19 19 0 0 0 2.213-2.837q.925-1.463.925-2.763 0-1.5-1-2.5t-2.5-1q-1.176 0-2 .538-.825.537-1.55 1.562a1.14 1.14 0 0 1-.95.5q-.276 0-.525-.125a1.14 1.14 0 0 1-.425-.375"
          ></path>
        </g>
      </g>
    </svg>
  );
}

export default HeartOutlinedIcon;
